import { useEffect, useState } from 'react';
import { useMount } from 'react-use';

import { ModalDescriptor } from './typings';

interface Props {
    modals: Array<ModalDescriptor>;
}

const getFirstModalWithPositiveDisplayConditions = (modals: Array<ModalDescriptor>) => {
    return modals.findIndex((modal: ModalDescriptor) => {
        const { ownDisplayCondition, contextDisplayCondition = true } = modal;
        return ownDisplayCondition && contextDisplayCondition;
    });
};

// компонент используется для модалок, которые не хотим показывать больше одной за сеанс,
// например чтобы не перегружать пользователя модалками про рассылку, соглашения и детей.
// все модалки сюда добавлять не нужно
export const ModalsBuilder = ({ modals }: Props) => {
    const [currentModalIndex, setCurrentModalIndex] = useState(-1);

    useMount(() => {
        const firstModalIndex = getFirstModalWithPositiveDisplayConditions(modals);
        setCurrentModalIndex(firstModalIndex);
    });

    useEffect(() => {
        const firstModalIndex = getFirstModalWithPositiveDisplayConditions(modals);
        const noModalShownYet = currentModalIndex === -1 && firstModalIndex >= 0;
        const noModalToDisplay = currentModalIndex !== -1 && firstModalIndex === -1;
        const hasNextModalToDisplay =
            currentModalIndex >= 0 && firstModalIndex >= 0 && currentModalIndex !== firstModalIndex;

        if (noModalShownYet) {
            setCurrentModalIndex(firstModalIndex);
        }

        if (noModalToDisplay || hasNextModalToDisplay) {
            setCurrentModalIndex(-1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modals]);

    return currentModalIndex >= 0 ? modals[currentModalIndex].component : null;
};
